// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "85bf2b84296e4289d9f9e1706a1c032a7be4bf6a/static/css/" + chunkId + "." + "9ae35b6f" + ".chunk.css";
};